module.exports = __webpack_public_path__ + "static/media/tempCard.2b15ac35.png";